import React from 'react';
import { motion } from 'framer-motion';

export default function BoasVindas() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="min-h-screen bg-gray-50"
    >
      <main className="flex flex-col items-center px-4 sm:px-8 md:px-16 lg:px-24 py-6 sm:py-10 gap-8 sm:gap-16">
        {/* Hero Section */}
        <motion.section 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-7xl"
        >
          {/* Hero Banner */}
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative w-full aspect-[16/9] sm:aspect-[21/9] mb-8 sm:mb-12 rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg"
          >
            <img
              src="https://firebasestorage.googleapis.com/v0/b/caryny.firebasestorage.app/o/midiainterna%2FNatalya%20(3).png?alt=media&token=14af1af4-6896-42a8-94ef-5284ff8237b6"
              alt="Hero Banner"
              className="w-full h-full object-cover"
            />
            
          </motion.div>

          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight text-gray-900">
            Menos curiosos, mais clientes prontos pra fechar
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6">
            Aumente suas vendas sem fazer nenhum esforço, com um espaço digital dedicado a você.
              
            </p>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="https://wa.me/5541992354647"
              className="inline-block bg-[#e91e63] text-white text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-200"
            >
              Quero mais clientes
            </motion.a>
          </div>
        </motion.section>

        {/* How it Works */}
        <motion.section 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="w-full max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"
        >
          <motion.div 
            whileHover={{ y: -5 }}
            className="text-center bg-white p-4 sm:p-6 rounded-2xl shadow-md"
          >
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/caryny.firebasestorage.app/o/midiainterna%2Fphoto_1_2025-05-08_11-59-21.jpg?alt=media&token=e844141d-99fc-46ce-a58a-24d987f9a4f1" 
              alt="Passo 1" 
              className="w-full aspect-square object-cover mx-auto mb-4 rounded-xl" 
            />
            <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-900">Sua marca, seu valor</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Uma página que mostra seu trabalho do jeito que ele merece, com foco em você e seus serviços.
            </p>
          </motion.div>

          <motion.div 
            whileHover={{ y: -5 }}
            className="text-center bg-white p-4 sm:p-6 rounded-2xl shadow-md"
          >
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/caryny.firebasestorage.app/o/midiainterna%2Fphoto_3_2025-05-08_11-59-21.jpg?alt=media&token=3f985eca-4220-46ff-8fc0-232cd5df1d96" 
              alt="Passo 2" 
              className="w-full aspect-square object-cover mx-auto mb-4 rounded-xl" 
            />
            <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-900">Invista em contatos qualificados</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Reduza em até 80% o número de pessoas que te chamam, mas não agendam.
            </p>
          </motion.div>

          <motion.div 
            whileHover={{ y: -5 }}
            className="text-center bg-white p-4 sm:p-6 rounded-2xl shadow-md"
          >
            <img 
              src="https://firebasestorage.googleapis.com/v0/b/caryny.firebasestorage.app/o/midiainterna%2Fphoto_2_2025-05-08_11-59-21.jpg?alt=media&token=22eb7f6c-c27e-4dee-a1ee-43e241f23b99" 
              alt="Passo 3" 
              className="w-full aspect-square object-cover mx-auto mb-4 rounded-xl" 
            />
            <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-900">Resultado real e rápido</h3>
            <p className="text-sm sm:text-base text-gray-600">
              Receba novos agendamentos em até 3 dias após a criação da página.
            </p>
          </motion.div>
        </motion.section>

        {/* Highlight Benefit */}
        <motion.section 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="w-full max-w-7xl text-center bg-white p-6 sm:p-8 rounded-2xl shadow-md"
        >
          <h2 className="text-2xl sm:text-3xl font-semibold mb-4 text-gray-900">
            Teste grátis por 7 dias
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Nossas clientes aumentam a renda em média 40% no primeiro mês.
            Sem precisar baixar preço, sem precisar anunciar em todo lugar.
          </p>
        </motion.section>

        {/* Pricing Section */}
        <motion.section 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="w-full max-w-7xl"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-10 text-gray-900">Invista no seu crescimento</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Basic Plan */}
            <motion.div 
              whileHover={{ y: -5 }}
              className="border rounded-xl p-4 sm:p-6 shadow-md text-center bg-white"
            >
              <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-900">Esquema FREE (7 dias)</h3>
              <p className="text-xl sm:text-2xl font-bold mb-4 text-[#e91e63]">R$0</p>
              <ul className="text-sm sm:text-base text-gray-600 space-y-2 mb-6">
                <li>Página personalizada pra você</li>
                <li>Novos agendamentos em até 3 dias</li>
                <li>Controle total sob seu trabalho</li>
                
              </ul>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="https://wa.me/5541992354647"
                className="inline-block bg-[#e91e63] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full hover:shadow-lg transition-all duration-200"
              >
                Quero testar
              </motion.a>
            </motion.div>

            {/* Professional Plan */}
            <motion.div 
              whileHover={{ y: -5 }}
              className="border rounded-xl p-4 sm:p-6 shadow-md text-center bg-white"
            >
              <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-900">Esquema PLUS</h3>
              <p className="text-xl sm:text-2xl font-bold mb-4 text-[#e91e63]">R$299/mês</p>
              <ul className="text-sm sm:text-base text-gray-600 space-y-2 mb-6">
              <li>Página PRO personalizada pra você</li>
                <li>Novos agendamentos em até 3 dias</li>
                <li>Controle total sob seu trabalho</li>
              </ul>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="https://wa.me/5541992354647"
                className="inline-block bg-[#e91e63] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full hover:shadow-lg transition-all duration-200"
              >
                Quero crescer mais
              </motion.a>
            </motion.div>

            {/* Elite Plan */}
            <motion.div 
              whileHover={{ y: -5 }}
              className="border rounded-xl p-4 sm:p-6 shadow-md text-center bg-white"
            >
              <h3 className="text-lg sm:text-xl font-semibold mb-2 text-gray-900">Esquema PRO</h3>
              <p className="text-xl sm:text-2xl font-bold mb-4 text-[#e91e63]">R$499/mês</p>
              <ul className="text-sm sm:text-base text-gray-600 space-y-2 mb-6">
              <li>Página ELITE personalizada pra você</li>
                <li>Explosão de novos clientes em até 3 dias</li>
                <li>Controle total sob seu trabalho</li>
               

              </ul>
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="https://wa.me/5541992354647"
                className="inline-block bg-[#e91e63] text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full hover:shadow-lg transition-all duration-200"
              >
                Quero ser destaque
              </motion.a>
            </motion.div>
          </div>
        </motion.section>

        
      </main>
    </motion.div>
  );
} 